import "./tab3.scss";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import * as React from "react";
import Dropdown from "../../../../../ui/dropdown/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";

const Tab3 = () => {
    const categoryDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const minPriceDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const dailyRetargetAutoCompleteItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const delayRetargetAutoCompleteItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const afterDelayRetargetAutoCompleteItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    return (
        <div className="Tab3">
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>دسته بندی محصولات</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-2 pb-1">کدام دست بندی سایت شما در تبلیغات دیده شود؟</h6>
                    <Dropdown items={categoryDropDownItems} placeHolder="انتخاب کنید"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-2 pb-1">حداقل قیمت محصول برای نمایش چقدر باشد؟</h6>
                    <Dropdown items={minPriceDropDownItems} placeHolder="انتخاب کنید"/>
                </div>
            </div>
            <div className="row pt-3">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>تنظیمات ریتارگتینگ</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">مخاطبان شما با چند روز تاخیر ریتارگت شوند؟</label>
                    <DropDown items={delayRetargetAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">مخاطبان شما تا چند روز بعد از تاخیر ریتارگت
                        شوند؟</label>
                    <DropDown items={afterDelayRetargetAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">مخاطبان شما حداکثر روزی چند بار ریتارگت شوند؟</label>
                    <DropDown items={dailyRetargetAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                </div>
            </div>
            <HorizontalDivider/>
        </div>
    );
}

export default Tab3